import React from 'react';
import { withRouter } from 'react-router-dom';

class Toolbar extends React.Component {
  render() {
    const {
      title = '',
      luxe,
      history = {},
      iconComponentLeft,
      iconComponentRight,
      resetButton,
      isFleek
    } = this.props;
    return (
      <div
        className={`rilrtl-toolbar ${
          luxe ? 'rilrtl-luxe-toolbar--fixed' : `rilrtl-toolbar--fixed ${isFleek ? 'fleek-toolbar--fixed' : ''}`
        }`}
      >
        <div className={luxe ? 'rilrtl-luxe-toolbar__row' : `rilrtl-toolbar__row ${isFleek && 'fleek-toolbar__row'}`}>
          <span
            className={luxe ? 'rilrtl-toolbar__luxeClearFilter' : 'rilrtl-toolbar__clearFilter'}
            style={{ display: !luxe && 'none',
              padding:"6px 0"
             }}
            aria-label='Reset filters'
            role='button'
            tabIndex={0}
          >
            <span className="clearFilterHidder">{resetButton}</span>
            Reset filters
          </span>
          <div
            className={
              luxe ? 'rilrtl-toolbar__icon--luxe-menu-right' : 'rilrtl-toolbar__icon--menu-right'
            }
          >
            {iconComponentRight || null}
          </div>
          <div 
            className={luxe ? 'rilrtl-toolbar__luxe-title' : `rilrtl-toolbar__title ${isFleek && 'fleek-toolbar-title'}`} 
            role="heading" 
            aria-level={2}
            aria-labelledby='rilrtl-toolbar__static-text rilrtl-toolbar__products-text'
          >
            <span 
              className="rilrtl-toolbar__static" 
              id="rilrtl-toolbar__static-text"
              aria-hidden="true"
            >
              {luxe ? 'FILTERS' : 'Filters'}
            </span>
            <span 
              className="rilrtl-toolbar__products" 
              id="rilrtl-toolbar__products-text"
              aria-hidden="true"
            >
              ({title})
            </span>
          </div>
        </div>
      </div>
    );
  }
}

/*
<div
  className="rilrtl-toolbar__icon--menu"
  onClick={() => {
    history.goBack();
  }}
>
  <i className="ic-back" />
</div> */

export default withRouter(Toolbar);
